import React, { useState, useCallback } from 'react';
import styled, { css } from 'styled-components';

import TX from '@Components/Common/Text';
import TextCSS from '@Components/Common/Text/Styles';

const ProjectInput = ({ input, setInput, maxLength, placeholder, isAbleMultiline }) => {
  const [isFocused, setIsFocused] = useState(false);

  const onFocus = useCallback(() => {
    setIsFocused(true);
  }, [isFocused]);

  const onBlur = useCallback(() => {
    setIsFocused(false);
  }, [isFocused]);

  const onChange = event => {
    const { value } = event.target;

    if (value.length > maxLength) {
      return;
    }

    setInput(value);
  };

  return (
    <Container>
      {isAbleMultiline ? (
        <StyledTextarea
          value={input}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      ) : (
        <StyledInput
          value={input}
          maxLength={maxLength}
          placeholder={placeholder}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}

      {isFocused ? (
        <MaxLengthContainer isAbleMultiline={isAbleMultiline}>
          <MaxLengthText>
            {input.length}/{maxLength}
          </MaxLengthText>
        </MaxLengthContainer>
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  margin: 0px 20px 20px 20px;
  position: relative;
`;

const CommonInputStyle = css`
  width: 100%;
  border: 0;

  &:focus {
    outline: none;
    caret-color: ${({ theme }) => theme.colors.ui_on_2};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors.ui_on_4};
    opacity: 1;
  }
`;

const StyledInput = styled.input`
  ${CommonInputStyle}
  ${TextCSS.Headline1}

  line-height: 48px;
`;

const StyledTextarea = styled.textarea`
  ${CommonInputStyle}
  ${TextCSS.BodyM}

  height: 89px;
  resize: none;
`;

const MaxLengthContainer = styled.div`
  width: 50px;
  text-align: right;
  position: absolute;
  top: ${props => (props.isAbleMultiline ? 0 : '13px')};
  left: -60px;
`;

const MaxLengthText = styled(TX.Caption1)`
  color: ${({ theme }) => theme.colors.ui_on_4};
`;

export default ProjectInput;
